export default "__VITE_ASSET__fESrv3hi__"